import _ from 'lodash';
import React from 'react';
import { uniqueKey } from '../../common/keys';
import ViewSettingsComponentWithProvider from '../../viewSettings/ViewSettingsComponent';
import { enablePatches, produceWithPatches } from "immer";
import { logPatches } from './reducerHelpers/logging';

enablePatches();

const rts = {
  addHelp: 'addHelp',
  onTransitionEnd: 'onTransitionEnd',
  removeItem: 'removeItem',
  setDataRoot: 'setDataRoot',
  setSelectedIndex: 'setSelectedIndex',
  swipeToItem: 'swipeToItem',
  // updateSettingsTemp: 'updateSettingsTemp',
}

export const viewSettingsComponentReducer = (state, action) => {

  console.log('>>> viewSettingsComponentReducer')

  const { isGlobal, appArea, selectedSettingGroup, swipedElements, swipedItems, swipeToSelected, addHelp } = state
  const { type, swipeProps } = action
  const { swipedItem, editProps } = swipeProps ?? {}
  const { key, subKey } = swipedItem ?? {}

  let keyy = 'vscp-' + key

  const [nextState, patches, inversePatches] = produceWithPatches(
    state,
    draft => {
      switch (type) {

        case rts.swipeToItem: {

          if (swipedItem) {

            const allSwipeItems = [...swipedItems, swipedItem]

            if (subKey) keyy += '-' + subKey
            if (editProps?.dataUpdateType) keyy += '-' + editProps.dataUpdateType
            if (subKey) keyy += '-' + subKey
            // if (updateProps.diKey) keyy += '-' + updateProps.diKey

            const ncProps = {
              appArea,
              addHelp,
              editProps,
              isGlobal,
              keyy,
              selectedSettingGroup,
              swipedItem,
              swipedItems: allSwipeItems,
              swipeToSelected,
            }

            const newElement = (
              <ViewSettingsComponentWithProvider
                key={uniqueKey('vscr', keyy)}
                ncProps={ncProps}
              />
            )

            draft.swipedElements.push(newElement)
            draft.swipedItems.push(swipedItem)
            draft.selectedIndex = draft.swipedElements.length - 1
            return
          }

          // removing swipe items
          if (swipedElements.length > 1) {
            draft.swipedElements.pop()
            draft.swipedItems.pop()
            draft.selectedIndex = draft.swipedElements.length - 1
          }
          return
        }

        case rts.setSelectedIndex: {
          if (draft.swipedElements.length > 1) {
            draft.swipedElements.splice(draft.swipedElements.length - 1, 1)
            draft.swipedItems.splice(draft.swipedItems.length - 1, 1)
            draft.selectedIndex = draft.swipedElements.length - 1
          }
          return
        }

        case rts.setDataRoot:
          draft.dataRoot = action.dataRoot
          return

        case rts.addHelp:
          draft.helpKey = action.viType
          return

        case rts.onTransitionEnd:
          return // no change

        // case rts.updateSettingsTemp:
        //   draft.settings_temp = action.settings_temp
        //   return

        default:
          return
      }

    }
  )

  logPatches('viewSettingsComponent', type, patches, action, nextState);

  return nextState;

}



export const viewSettingsComponentHandlers = (dispatch) => {
  return {
    addHelp: (viType) => {
      const swipeProps = { swipedItem: { helpKey: viType, key: viType, caption: 'Help' } }
      dispatch({ type: rts.swipeToItem, swipeProps })
    },
    onTransitionEnd: (selectedIndex) => { dispatch({ type: rts.onTransitionEnd, selectedIndex: selectedIndex }) },
    setDataRoot: (dataRoot) => { dispatch({ type: rts.setDataRoot, dataRoot }) },
    setSelectedIndex: (selectedIndex) => { dispatch({ type: rts.setSelectedIndex, selectedIndex: selectedIndex }) },
    swipeToItem: (swipeProps) => { dispatch({ type: rts.swipeToItem, swipeProps }) },
    // updateSettingsTemp: (settings_temp) => { dispatch({ type: rts.updateSettingsTemp, settings_temp }) },
    swipeToSelected: (swipeProps) => { dispatch({ type: rts.swipeToItem, swipeProps }) },
  }
}

export const viewSettingsComponentInitialState = (props) => {

  const { componentContexts, logging, addHelp, swipeToSelected, settings_globalPageItems, startSwipeItems, ncProps: ncProps_as } = props

  // componentContexts
  const { settingsAreaContext, viewSettingsContext } = componentContexts
  const { settingsArea_state } = settingsAreaContext ?? {}
  const { selectedSettingGroup, isGlobal } = settingsArea_state ?? {}
  const { viewSettings_state } = viewSettingsContext
  let { settings_temp, settings_temp_global, selectedGroupItem } = viewSettings_state

  // IMPORTANT: Settings - set the swipeItem
  const swipedItem = selectedGroupItem ? { key: selectedGroupItem.key, settingKey: selectedGroupItem.key, viType: selectedGroupItem.key, caption: selectedGroupItem.caption } : null
  const swipedItems = swipedItem ? [swipedItem] : []

  const ncProps = ncProps_as ? ncProps_as : {
    addHelp,
    isGlobal,
    swipedItem,
    swipedItems,
    swipeToSelected,
  }

  const newElement = <ViewSettingsComponentWithProvider key={uniqueKey('vscr')} ncProps={ncProps} />

  const state = {
    addHelp,
    isGlobal,
    logging,
    selectedIndex: startSwipeItems ? 1 : 0,
    selectedSettingGroup,
    settings_globalPageItems,
    swipedItem: startSwipeItems ? startSwipeItems[0] : swipedItem,
    swipedItems: startSwipeItems ? startSwipeItems : swipedItems,
    swipeToSelected,
    settings_temp,
    settings_temp_global,
    swipedElements: [newElement]
  }

  return state

};
